import { render, staticRenderFns } from "./PlacesWorkPlans.vue?vue&type=template&id=384b0d2c&"
import script from "./PlacesWorkPlans.vue?vue&type=script&lang=js&"
export * from "./PlacesWorkPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports